import { Component, ComponentRef, ElementRef, OnDestroy, OnInit, inject, signal } from "@angular/core";

import { AlertBadge } from "@models";
import { AlertService } from "@services";
import { Utils } from "@utils";

@Component({ template: "" })
export abstract class AbstractAlertComponent implements OnInit, OnDestroy {
  private readonly alS = inject(AlertService);
  protected readonly eR = inject(ElementRef);

  public text = signal<string>("");
  public message = signal<string>("");
  public color = signal<string>("");
  public badge = signal<AlertBadge>(AlertBadge.I);

  public infinite: boolean;

  protected abstract sec: number;

  public ref: ComponentRef<AbstractAlertComponent>;

  private iTimer: ReturnType<typeof setTimeout>;
  private oTimer: ReturnType<typeof setTimeout>;
  private rTimer: ReturnType<typeof setTimeout>;

  public set state(_state: "fade-in" | "fade-out") {
    this.add(_state);
  }

  public abstract set index(_index: number);

  public ngOnInit(): void {
    this.add("alert");

    if (this.infinite) {
      this.state = "fade-in";
    } else {
      this.startTimer();
    }
  }

  public ngOnDestroy(): void {
    this.clear();
  }

  private clear(): void {
    clearTimeout(this.iTimer);
    clearTimeout(this.oTimer);
    clearTimeout(this.rTimer);
  }

  private startTimer(delay: number = 0): void {
    this.iTimer = setTimeout(() => {
      this.state = "fade-in";

      this.oTimer = setTimeout(() => {
        this.state = "fade-out";

        this.rTimer = setTimeout(() => this.alS.remove(this.ref), Utils.duration);
      }, Utils.second * this.sec);
    }, delay);
  }

  protected translateY(_index: number): string {
    return `translateY(calc(${100 * _index}% + ${10 * _index}px))`;
  }

  private add(name: string): void {
    this.eR.nativeElement.classList.add(name);
  }
}
